import { Box, Button, Text, VStack } from '@chakra-ui/react'
import { ChevronRight } from 'lucide-react'
import { useThemeColors } from '@/hooks/useThemeColors'

export type QuickLinkItem = {
  id: string
  label: string
  count?: number
  onClick: () => void
}

type Props = {
  links: QuickLinkItem[]
}

export default function OverviewQuickLinks({ links }: Props) {
  const colors = useThemeColors()

  if (links.length === 0) return null

  return (
    <Box pt={4} borderTop="1px solid" borderColor={colors.borderLight}>
      <Text
        fontSize="xs"
        fontWeight="700"
        color={colors.textSecondary}
        textTransform="uppercase"
        letterSpacing="wider"
        mb={2}
      >
        Quick links
      </Text>
      <VStack align="stretch" spacing={1}>
        {links.map((link) => (
          <Button
            key={link.id}
            variant="ghost"
            size="sm"
            justifyContent="space-between"
            fontWeight="500"
            color={colors.text}
            rightIcon={<ChevronRight size={14} />}
            onClick={link.onClick}
            px={2}
          >
            <Text as="span" flex="1" textAlign="left">
              {link.label}
              {link.count != null && link.count > 0 ? ` (${link.count})` : ''}
            </Text>
          </Button>
        ))}
      </VStack>
    </Box>
  )
}
